import React, { ReactElement } from "react";
import Nachu from "@templates/Initiatives/Nachu";
import TemplateSEO from "@seo/TemplateSEO";

interface Props {}

export default function NachuPage({}: Props): ReactElement {
    return (
        <>
            {/* @ts-ignore */}
            <TemplateSEO
                title="Inuua na NACHU"
                description="Inuua na NACHU is an initiative to help people build their own homes, starting with affordable plans, designed for affordable modern luxury function and looks at RiverLine Ridges!"
            />
            <Nachu />
        </>
    );
}
